import { z } from "zod";

export const expressionKindSchema = z.enum(["expression", "measure", "numberOrExpression"]);

export type ExpressionKind = z.infer<typeof expressionKindSchema>;

export const expressionInputSchema = z.object({
  id: z.string(),
  expression: z.string(),
  kind: expressionKindSchema,
});

export type ExpressionInput = z.infer<typeof expressionInputSchema>;

export const expressionCheckResultSchema = z.object({
  id: z.string(),
  valid: z.boolean(),
  errorMsg: z.string(),
  badFieldNames: z.array(z.string()),
  dangerousFieldNames: z.array(z.string()),
});

export type ExpressionCheckResult = z.infer<typeof expressionCheckResultSchema>;

export const checkExpressionsResponseSchema = z.object({
  results: z.array(expressionCheckResultSchema),
});

export type CheckExpressionsResponse = z.infer<typeof checkExpressionsResponseSchema>;

export const appExpressionCheckResultSchema = z.object({
  appId: z.string(),
  appName: z.string(),
  results: z.array(expressionCheckResultSchema),
});

export type AppExpressionCheckResult = z.infer<typeof appExpressionCheckResultSchema>;

export const checkGroupExpressionsResponseSchema = z.object({
  results: z.array(appExpressionCheckResultSchema),
});

export type CheckGroupExpressionsResponse = z.infer<typeof checkGroupExpressionsResponseSchema>;
